/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MeetingNotificationsCleanupParams } from './meetingNotificationsCleanupParams';

/**
 * Request model for meeting notifications cleanup job
 */
export interface RunMeetingNotificationsCleanupJobRequest {
  type: 'meeting_notifications_subscriptions_cleanup';
  params: MeetingNotificationsCleanupParams;
  allowOverlappingJobs?: boolean;
}
